namespace GeniuzPOS.ReportMasterData {
    export interface Report_1403Row {
        Id?: string;
        DocTime?: string;
        DocDate?: string;
        GrossSales?: number;
        AllItemDiscount?: number;
        NetSales?: number;
        NetSalesExVat?: number;
        VatOfNetSales?: number;
        AllItemCharge?: number;
        VatOfCharge?: number;
    }

    export namespace Report_1403Row {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'ReportMasterData.Report_1403';
        export const deletePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:ยอดขายรวมร้านค้า:View';
        export const insertPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:ยอดขายรวมร้านค้า:View';
        export const readPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:ยอดขายรวมร้านค้า:View';
        export const updatePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:ยอดขายรวมร้านค้า:View';

        export declare const enum Fields {
            Id = "Id",
            DocTime = "DocTime",
            DocDate = "DocDate",
            GrossSales = "GrossSales",
            AllItemDiscount = "AllItemDiscount",
            NetSales = "NetSales",
            NetSalesExVat = "NetSalesExVat",
            VatOfNetSales = "VatOfNetSales",
            AllItemCharge = "AllItemCharge",
            VatOfCharge = "VatOfCharge"
        }
    }
}
